import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection, ActionPlanModel } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    selector: 'date-plugin',
    templateUrl: './date.component.html',
    standalone: false
})
export class DatePluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public date: string;
  public inspection: Inspection | ActionPlanModel;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection | ActionPlanModel,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    this.plugin = plugin;
    this.initData();
    this.date = this.plugin.config.Date;
    this.inspection = inspection;
    this.showBreadcrumbs = showBreadcrumbs;
    this.showContent = showContent;
    this.showValidations = showValidations;
    this.messages = messages;
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute(comment: any) {
    return [
      this.actionPlansRoute,
      this.plugin.actionPlanId,
      'actionplanitems',
      this.plugin.actionPlanItemId,
      'plugins',
      this.plugin.id,
      'date',
      'edit'
    ];
  }
}

PluginComponent.plugins['date'] = DatePluginComponent;
